/*
  SmartLiv — slideshow com altura adaptada à imagem de cada slide.
  Quando as imagens têm proporções diferentes, a altura do banner acompanha o slide visível.
*/
(function () {
  function setup(slider) {
    if (!slider || slider.dataset.smartlivAdapt === 'true') return;
    slider.dataset.smartlivAdapt = 'true';

    var frame = null;

    function slides() {
      return Array.prototype.slice.call(slider.querySelectorAll('.slideshow__slide'));
    }

    function activeSlide() {
      var list = slides();
      if (!list.length) return null;
      var width = slider.clientWidth || 1;
      var index = Math.round(Math.abs(slider.scrollLeft) / width);
      return list[Math.min(Math.max(index, 0), list.length - 1)];
    }

    function apply() {
      frame = null;
      var slide = activeSlide();
      if (!slide) return;
      var height = slide.getBoundingClientRect().height;
      if (height > 0) slider.style.height = height + 'px';
    }

    function schedule() {
      if (frame === null) frame = window.requestAnimationFrame(apply);
    }

    slider.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(schedule);
      slides().forEach(function (slide) {
        observer.observe(slide);
      });
    }

    slider.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', schedule, { once: true });
    });

    schedule();
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.slideshow.banner--adapt_image:not(.slideshow--placeholder)')
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Editor de temas da Shopify: seção recarregada
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
